import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/sections/HeroSection';
import TrustBar from '../../components/sections/TrustBar';
import ServicesOverview from '../../components/sections/ServicesOverview';
import AIAnswerBlock from '../../components/sections/AIAnswerBlock';
import ProcessSection from '../../components/sections/ProcessSection';
import WhyChooseUsSection from '../../components/sections/WhyChooseUsSection';
import ServiceAreasSection from '../../components/sections/ServiceAreasSection';
import SocialProofSection from '../../components/sections/SocialProofSection';
import FAQSection from '../../components/sections/FAQSection';
import FinalCTASection from '../../components/sections/FinalCTASection';

const homeServices = [
  {
    image: 'https://public.readdy.ai/ai/img_res/594766409729e37ba3af513cd877c298.jpg',
    title: 'Polished Concrete',
    description: 'Economical, durable, and low-maintenance flooring for new construction and existing slabs. Residential homes to large commercial facilities.',
    href: '/services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=professional%20concrete%20floor%20restoration%20close%20up%20diamond%20grinding%20machine%20in%20action%20on%20worn%20concrete%20surface%20industrial%20space%20dramatic%20side%20lighting%20transformation%20workmanship%20premium%20quality%20photography&width=600&height=760&seq=hmsvc02&orientation=portrait',
    title: 'Concrete Restoration',
    description: 'Revitalize worn or damaged concrete using grinding, sealing, overlays, and full diamond polishing — at a fraction of replacement cost.',
    href: '/services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=seamless%20metallic%20epoxy%20floor%20coating%20commercial%20warehouse%20interior%20cool%20gray%20tones%20high%20gloss%20surface%20reflecting%20industrial%20overhead%20lights%20clean%20lines%20modern%20premium%20professional%20finish%20photography&width=600&height=880&seq=hmsvc03&orientation=portrait',
    title: 'Floor Coatings',
    description: 'Industrial, commercial, and residential coatings precisely matched to your environment, performance requirements, and aesthetic.',
    href: '/services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=custom%20business%20logo%20embedded%20permanently%20into%20polished%20concrete%20floor%20retail%20showroom%20colorful%20durable%20brand%20mark%20geometric%20design%20high%20gloss%20surface%20architectural%20detail%20close%20up%20photography&width=600&height=760&seq=hmsvc04&orientation=portrait',
    title: 'Custom Graphics & Logos',
    description: 'Unique custom logos and graphics embedded directly into concrete — ideal for retail, sports facilities, schools, and corporate lobbies.',
    href: '/services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=luxury%20terrazzo%20floor%20close%20up%20polished%20white%20marble%20and%20colored%20stone%20chips%20set%20in%20cream%20cement%20matrix%20high%20gloss%20reflective%20surface%20premium%20interior%20architectural%20detail%20photography%20warm%20tones&width=600&height=880&seq=hmsvc05&orientation=portrait',
    title: 'Terrazzo',
    description: 'Composite marble, quartz, and glass chips set in cement or epoxy, then polished to a luxurious finish — timeless and exceptionally durable.',
    href: '/services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=smooth%20fresh%20cement%20overlay%20resurfacing%20on%20residential%20interior%20floor%20clean%20cream%20warm%20tones%20modern%20living%20space%20transformation%20before%20after%20dramatic%20lighting%20premium%20home%20improvement%20photography&width=600&height=760&seq=hmsvc06&orientation=portrait',
    title: 'Resurfacing',
    description: 'Cement-based toppings applied over existing concrete to create a fresh, smooth, decorative surface without full slab replacement.',
    href: '/services',
  },
];

const homeQAs = [
  {
    question: 'What does Polished Concrete Plus do?',
    answer: 'Polished Concrete Plus creates colorful and durable interior flooring finishes and decorative concrete exterior hardscapes for both residential and commercial projects across Minnesota and surrounding states. Founded in 2003, our certified concrete construction managers handle every project from start to finish.',
  },
  {
    question: 'What types of services are offered?',
    answer: 'We specialize in polished concrete, concrete restoration, floor coatings (epoxy and polyurea), custom graphics and logos embedded in concrete, terrazzo installation, and concrete resurfacing with cement-based toppings. Every service is available for residential and commercial applications.',
  },
  {
    question: 'What are the benefits of polished concrete flooring?',
    answer: 'Polished concrete is economical, highly durable, requires minimal maintenance, and works on both new and decades-old concrete. It\'s a sustainable choice that enhances aesthetics without replacing the existing slab — ideal for homes, retail, warehouses, and institutional spaces.',
  },
  {
    question: 'Who is polished concrete and floor coating right for?',
    answer: 'It\'s ideal for homeowners seeking low-maintenance beauty, commercial spaces requiring durable industrial-grade floors, contractors who need certified installers with 20+ years of regional expertise, and property owners across Minnesota, Iowa, Wisconsin, North Dakota, and South Dakota.',
  },
];

const homeSteps = [
  { number: '01', title: 'Free Consultation', description: 'Free on-site estimate and surface evaluation to determine the best approach and system for your project.', icon: 'ri-discuss-line' },
  { number: '02', title: 'Surface Prep', description: 'Professional diamond grinding and surface preparation ensures the best adhesion, clarity, and finish quality.', icon: 'ri-tools-line' },
  { number: '03', title: 'Application', description: 'Expert application of the selected system — polish progressions, coating layers, overlay, or terrazzo matrix.', icon: 'ri-paint-brush-line' },
  { number: '04', title: 'Detail Work', description: 'Perimeter edges, transitions, and decorative accents finished by hand with precision craftsmanship on every project.', icon: 'ri-star-line' },
  { number: '05', title: 'Final Inspection', description: 'Quality control inspection before handoff — every project meets our premium standard before delivery.', icon: 'ri-shield-check-line' },
];

const homeReasons = [
  {
    icon: 'ri-medal-fill',
    title: 'Proven Craftsmanship',
    points: [
      'Established 2003 — over 20 years of certified expertise',
      'Originally Polished Concrete Images, rebranded 2011',
      'Certified concrete construction managers on every project',
      'Residential and commercial grade results, every time',
    ],
  },
  {
    icon: 'ri-gem-fill',
    title: 'Premium Materials & Methods',
    points: [
      'Diamond polishing systems for superior clarity and gloss',
      'High-performance industrial-grade epoxy and polyurea coatings',
      'Genuine terrazzo materials in cement and epoxy matrix',
      'Permanent embedded graphics and custom logo work',
    ],
  },
  {
    icon: 'ri-customer-service-2-fill',
    title: 'Reliability & Reach',
    points: [
      'Free consultations and detailed on-site estimates',
      'Serving MN, IA, WI, ND, and SD',
      'Residential to large-scale commercial projects',
      'Direct contact: 320.493.1454',
    ],
  },
];

const homeAreas = [
  {
    state: 'Minnesota (Primary)',
    cities: ['Minneapolis', 'St. Paul', 'Duluth', 'Rochester', 'St. Cloud', 'Moorhead', 'Sauk Rapids', 'Rice'],
  },
  {
    state: 'Surrounding States',
    cities: ['Iowa', 'Wisconsin', 'North Dakota', 'South Dakota'],
  },
];

const homeFAQs = [
  {
    question: 'Who offers polished concrete near Minneapolis, MN?',
    answer: 'Polished Concrete Plus is Minnesota\'s premier installer of polished concrete, serving Minneapolis, St. Paul, Duluth, Rochester, St. Cloud, and Moorhead. Founded in 2003 and headquartered in Sauk Rapids, MN, we bring 20+ years of certified expertise to every residential and commercial project in the Twin Cities and beyond.',
  },
  {
    question: 'How much does polished concrete cost in Minnesota?',
    answer: 'Polished concrete cost depends on square footage, the condition of the existing slab, and the finish level selected. Polished Concrete Plus offers free on-site consultations and estimates — call 320.493.1454 to schedule yours today with no obligation and no pressure.',
  },
  {
    question: 'How long does polished concrete installation take?',
    answer: 'Most residential polished concrete projects are completed in 1–3 days. Commercial projects vary based on size and complexity. After our free on-site assessment, we provide a clear written timeline before any work begins, so you can plan your project accordingly.',
  },
  {
    question: 'Is epoxy or floor coating durable for a commercial space?',
    answer: 'Absolutely. Polished Concrete Plus applies industrial-grade coatings rated for heavy traffic, chemical exposure, and temperature fluctuation. We carefully match the coating specification to your specific residential or commercial environment, ensuring maximum performance and long-term durability.',
  },
  {
    question: 'Can old or damaged concrete be restored instead of replaced?',
    answer: 'Yes — concrete restoration is one of our core specialties. Using grinding, sealing, overlays, and full diamond polished systems, we revitalize worn and damaged concrete — including slabs over 50 years old. In most cases, restoration delivers superior results at a fraction of replacement cost.',
  },
  {
    question: 'Does Polished Concrete Plus serve areas outside Minnesota?',
    answer: 'Yes. In addition to serving cities across Minnesota, Polished Concrete Plus travels into Iowa, Wisconsin, North Dakota, and South Dakota for qualified commercial and residential projects. Call 320.493.1454 to discuss your specific location and get a free estimate for your project.',
  },
];

export default function Home() {
  return (
    <main>
      <Navbar />

      <HeroSection
        backgroundImage="https://readdy.ai/api/search-image?query=cinematic%20wide%20angle%20interior%20of%20luxury%20modern%20commercial%20space%20with%20stunning%20high%20gloss%20polished%20concrete%20floor%20reflecting%20dramatic%20warm%20pendant%20lights%20above%20dark%20moody%20atmospheric%20charcoal%20tones%20deep%20shadows%20premium%20architectural%20photography%208k%20quality&width=1920&height=1080&seq=hmhero01&orientation=landscape"
        eyebrow="Minnesota's Premier Concrete Specialists — Est. 2003"
        headline="Colorful. Durable."
        headlineAccent="Decorative Concrete Finishes."
        subheadline="Interior flooring finishes and decorative concrete hardscapes for residential and commercial projects across Minnesota and beyond. Certified installers since 2003."
        ctaText="Request a Free Estimate"
        ctaHref="#contact"
        secondaryCtaText="Explore Our Services"
        secondaryCtaHref="/services"
      />

      <TrustBar />

      <ServicesOverview
        eyebrow="Core Services"
        headline="Surface Finishing at the Highest Level"
        subheadline="From polished concrete to industrial coatings — precision craftsmanship on every surface."
        services={homeServices}
      />

      <AIAnswerBlock
        eyebrow="What We Do — Clear Answers"
        headline="The Premier Choice for Polished Concrete in Minnesota"
        intro="Polished Concrete Plus has delivered exceptional decorative concrete and surface finishing since 2003. Here's exactly what you need to know about our services, benefits, and approach."
        qas={homeQAs}
      />

      <ProcessSection
        eyebrow="Our Process"
        headline="From Consultation to Flawless Finish"
        steps={homeSteps}
      />

      <WhyChooseUsSection
        eyebrow="Why Choose Us"
        headline="The Standard for Polished Concrete in the Region"
        subheadline="Two decades of certified experience, premium materials, and an unwavering commitment to quality on every residential and commercial project."
        reasons={homeReasons}
        backgroundImage="https://readdy.ai/api/search-image?query=dramatic%20close%20up%20macro%20polished%20concrete%20floor%20surface%20high%20gloss%20reflective%20deep%20charcoal%20tones%20with%20warm%20amber%20light%20reflections%20dramatic%20shadows%20texture%20detail%20industrial%20luxury%20premium%20photography&width=900&height=1100&seq=hmwhy01&orientation=portrait"
      />

      <ServiceAreasSection
        eyebrow="Service Areas"
        headline="Serving Minnesota & Surrounding States"
        subheadline="Based in Sauk Rapids, MN — we travel across the region to deliver premium concrete finishing wherever you need it."
        areas={homeAreas}
        showMap
      />

      <SocialProofSection />

      <FAQSection
        eyebrow="Frequently Asked Questions"
        headline="Everything You Need to Know"
        faqs={homeFAQs}
      />

      <FinalCTASection
        headline="Ready to Elevate Your Space?"
        subheadline="Contact Polished Concrete Plus today for a free consultation and estimate. Residential, commercial, and industrial projects across MN, IA, WI, ND &amp; SD."
        backgroundImage="https://readdy.ai/api/search-image?query=warm%20luxury%20interior%20residential%20living%20space%20beautiful%20polished%20concrete%20floor%20glowing%20amber%20lighting%20elegant%20home%20design%20high%20ceiling%20modern%20architecture%20premium%20photography%20atmospheric&width=1920&height=1080&seq=hmcta01&orientation=landscape"
      />

      <Footer />
    </main>
  );
}
